import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  Feature,
  FeatureActionFields,
  FeatureCommands,
  FeatureNames,
  FeaturePropertyKey,
  GenericTemperatureProperty,
  VentilationBypassModeCommands,
  VentilationBypassModeProperties,
  VentillationBypassTemperatureCommands,
  VentilationBypassConfigurationCommands,
  VentilationBypassConfigurationProperties,
  VentilationModes,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { GTMService } from '../../../../shared/services';

@Component({
  selector: 'app-ventilation-bypass',
  templateUrl: './ventilation-bypass.component.html',
  styleUrls: ['./ventilation-bypass.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VentilationBypassComponent implements OnInit {
  featurePropertyKey = FeaturePropertyKey;
  featureCommands = FeatureCommands;
  VentilationModes = VentilationModes;

  ventilationBypassMode$: Observable<
    Feature<VentilationBypassModeProperties, VentilationBypassModeCommands>
  >;

  configurationTemperatureSupply$: Observable<
    Feature<GenericTemperatureProperty, VentillationBypassTemperatureCommands>
  >;
  configurationTemperaturePerceived$: Observable<
    Feature<GenericTemperatureProperty, VentillationBypassTemperatureCommands>
  >;

  ventilationBypassConfiguration$: Observable<
    Feature<VentilationBypassConfigurationProperties, VentilationBypassConfigurationCommands>
  >;

  constructor(
    private gtmService: GTMService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.ventilationBypassMode$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationBypassMode
    );
    this.configurationTemperatureSupply$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationBypassConfigurationTemperatureSupply
    );
    this.configurationTemperaturePerceived$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationBypassConfigurationTemperaturePerceived
    );
    this.ventilationBypassConfiguration$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationBypassConfiguration
    );
  }

  onBypassOptionChange(option: { value: string }): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.ventilationBypassMode,
      option.value,
      'value',
      'mode',
      'setMode'
    );
  }

  onBypassConfigurationTemperatureChange(temperatureValue: number, featureName: string): void {
    this.installationFeaturesStore.updateFeature(
      featureName,
      temperatureValue,
      FeaturePropertyKey.value,
      FeatureActionFields.temperature, // TODO in https://jira.viessmann-climatesolutions.com/browse/VIG-15203 verify which field to send
      FeatureCommands.setTemperature
    );
  }

  trackVentilationBypassMode(): void {
    this.gtmService.track('onSelect', 'Ventilation`s bypass mode', 'bypassMode');
  }

  onBypassConfigurationChange(option: { value: string }): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.ventilationBypassConfiguration,
      option.value,
      FeaturePropertyKey.value,
      '',
      FeatureCommands.setValue
    );
  }
}
